import React from 'react'

import LayersNav from './LayersNav'
import ProjectsNav from './ProjectsNav'
import useStore from '../../hooks/useStore'

const MapNav = () => {
  const { state, dispatch } = useStore()
  const { data, activeLayer, activeProject, lang } = state

  // Destructure Layer description value and pass it as a prop
  // to LayersNav, since that's we are rendering it.
  const activeLayerData = data.find(({ id }) => id === activeLayer)

  // Return the list of projects inside the activeLayerData
  const projects = activeLayerData.entries.map(project => ({
    ...project
  }))

  // Format layers to add a link attribute with custom paths names
  const layers = data.map(layer => ({
    ...layer,
    link: `/map/${layer.id}`
  }))

  return (
    <>
      <LayersNav
        content={layers}
        layerDescription={activeLayerData.description}
        activeLayer={activeLayer}
        dispatch={dispatch}
        lang={lang}
      />
      <ProjectsNav
        activeProject={activeProject}
        dispatch={dispatch}
        content={projects}
        lang={lang}
      />
    </>
  )
}

export default MapNav
